import { ImageProps } from "next/image";
import { designer } from "./designer.variants";

export type UseDesignerProps = ComponentProps<{
  name: string;
  image: ImageProps["src"];
}>;

export const useDesigner = (props: UseDesignerProps) => {
  const { className = "", data } = props;

  const styles = designer();

  return {
    className,
    styles,
    data,
  };
};
